export enum ActiveJobsExplorer {
  Delete = 0,
  Export = 1,
}